import { InboundShipment } from "@deliverr/inbound-client";

export const getNonEmptyShipmentItems = (shipment: InboundShipment) => shipment.items.filter((item) => item.qty > 0);
